export default "__VITE_ASSET__CW_lCIUa__"